import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { apiBaseUrl } from "network"


export const usersApi = createApi({
    reducerPath: "usersApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl, prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllUsers: builder.query({
            query: ({ page, limit, search, startDate, endDate }) => ({
                url: `/backend/v1/common/users?page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`
            }),
            transformResponse: (response) => response
        }),
        getAllOrders: builder.query({
            query: ({ page, limit, search }) => ({
                url: `vendor/orders?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response
        }),
        getAllCustomers: builder.query({
            query: ({ page, limit, search }) => ({
                url: `vendor/customers?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response
        }),

        updateUser: builder.mutation({
            query: ({ id, body }) => ({ url: `/backend/v1/common/users/${id}`, method: "PUT", body: body }),
        }),


        getCustomerDetail: builder.query({
            query: ({ id, page, limit, search }) => ({
                url: `vendor/scanlist/${id}?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response
        }),

        updateVendor: builder.mutation({
            query: ({ id, body }) => ({
                url: `vendor/update/${id}`,
                method: "PUT",
                body,
            }),
        }),


    })
})

export const { useGetAllUsersQuery, useGetAllOrdersQuery, useGetAllCustomersQuery, useGetCustomerDetailQuery, useUpdateUserMutation, useUpdateVendorMutation } = usersApi